import React, { ReactElement } from "react";
import scrmLogo from "../../public/images/svg/scrmLogo.svg";
import UserProfileMenu from "../components/UserProfileMenu/UserProfileMenu";

/**
 * Header Component
 * Consolidated styling: .header--main .header--fixed from src/styles/components.css
 *
 * REFACTOR NOTES:
 * - Replaced inline Tailwind with component classes
 * - Maintains fixed positioning and z-index via .header--fixed
 */
export default function Header(): ReactElement {
  const render = () => (
    <header className="header--main header--fixed">
      <div
        id="header-content"
        className="flex flow-row items-center h-full justify-between"
      >
        <div id="branding-area" className="pl-4 flex-1">
          <a href="/" className="flex flex-row">
            <img src={scrmLogo} className="h-8 mx-2" alt="Logo" />
          </a>
        </div>
        <div
          id="header-links"
          className="h-full flex flex-auto items-center justify-center"
        ></div>
        <UserProfileMenu />
      </div>
    </header>
  );

  return render();
}
